export default __webpack_public_path__ + "static/clients_codebook-d4be8ab7e4dca01b1cfaf25057b08f85.pdf";